var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09349 6.84067C7.03516 6.83484 6.96516 6.83484 6.90099 6.84067C5.51266 6.794 4.41016 5.6565 4.41016 4.2565C4.41016 2.82734 5.56516 1.6665 7.00016 1.6665C8.42932 1.6665 9.59016 2.82734 9.59016 4.2565C9.58432 5.6565 8.48182 6.794 7.09349 6.84067Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17691 8.9935C2.76525 9.9385 2.76525 11.4785 4.17691 12.4177C5.78108 13.491 8.41191 13.491 10.0161 12.4177C11.4277 11.4727 11.4277 9.93266 10.0161 8.9935C8.41775 7.926 5.78691 7.926 4.17691 8.9935Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.076507826a747e1192c8116aaad6c266.svg";
export { ForwardRef as ReactComponent };